import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import DropDown      from 'dropdown';
import ContentsTab   from 'contents_tab';
import CastingCommon from '@utils/casting-common';

import SummaryMainScore  from './parts/main-score';

import ReportDownload  from '@project/contents/report/parts/report-download';
import ReportCreate    from '@project/contents/report/parts/report-create';
import ReportEdit      from '@project/contents/report/parts/report-edit';

import ReportSummary   from '@project/contents/report/contents/summary';
import ReportList      from '@project/contents/report/contents/list';
import ReportMembers   from '@project/contents/report/contents/members';
import ReportProfiling from '@project/contents/report/contents/profiling';
// -------------------------------------------------------

class Report extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      tab : Utils.getLocalData({ id: 'project/report/tab', default: 'list' }),
    };
  }
  // -------------------------------------------------------
  
  /*
   * ナビの変更
   */
  changeNavigation(tab) {
    this.setState({ tab: tab });
    Utils.saveLocalData({ id: 'project/report/tab', data: tab });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    // 通知件数の取得
    let members_count = 0;
    for( let insta_user_id in data.workflow.influencers ){
      if( CastingCommon.getReportSelectTarget(data, insta_user_id) == true ) members_count += 1;
    }
    
    let tabs = [
      //{ id: 'summary',  name: '概要',             html: <ReportSummary data={data} /> },
      { id: 'list',     name: '投稿一覧',         html: <ReportList data={data} /> },
      { id: 'task',     name: 'プロファイリング', html: <ReportProfiling data={data} /> },
      { id: 'members',  name: '投稿登録',         html: <ReportMembers data={data} />, pop_count: members_count },
      //{ id: 'report',   name: '数値確認',         html: <ReportList data={data} is_check={true} /> },
    ];
    
    return (
      <div className="project-report">
        <div className="report-contents">
          
          <div className="report-buttons">
            <ReportCreate data={data} />
            <ReportEdit data={data} />
            <ReportDownload data={data} />
          </div>
          
          <div className="summary-contents-left">
            <SummaryMainScore data={data} />
          </div>
          
          <div className="report-container">
            <ContentsTab tabs={tabs} select={this.state.tab} font_size={14} change_ev={this.changeNavigation.bind(this)} />
          </div>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Report;